import React, { useEffect, useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton.js";

import Modal1 from "../modals/Modal1.js";

import PDF from "../pdf/PDF.js";
import downloadFile from "../api/download/downloadFile.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import {
  getDocDataById,
  getDocDataByRef,
  listenDocDataByRef,
  updateDocDataField,
} from "../models/DataFunctions.js";
import { generateKey } from "../portal/InvoiceSign.js";
import downloadMultiPDF from "../api/download/downloadMultiPDF.js";
import PDFModal from "../pdf/PDFModal.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import sendAvailableReportsEmail from "../api/send/sendAvailableReportsEmail.js";
import { useSnackbar } from "notistack";
import Tippy from "@tippyjs/react";
import { isFolderMaster } from "../hexagone/VisibilityHelpers.js";

const PaymentRapportVisualisateur = ({
  folder,
  orgData,
  userData,
  payment_id,
  prefix,
  handleUpdate,
}) => {
  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [loadingFile, setLoadingFile] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const handleLoadUrl = async () => {
    setLoadingFile(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "rapport-payment", "", folder.id, prefix);
    let folderData = await getDocDataByRef(folder.ref);
    let paymentData = await getDocDataById("payment", payment_id);
    setPaymentData(paymentData);
    let files = paymentData?.rapport_files;
    if (files) setFiles(files);
    setLoadingFile(false);
  };
  const handleFetchData = async () => {
    let paymentData = await getDocDataById("payment", payment_id);
    setPaymentData(paymentData);
    let files = paymentData?.rapport_files;
    if (files) setFiles(files);
  };

  const [unsubscribe, setUnsubscribe] = useState(null);

  useEffect(() => {
    // set up listener to payment
    if (!paymentData?.ref) {
      return;
    }
    const unsubscribe = listenDocDataByRef(paymentData?.ref, (data) => {
      setPaymentData(data);
      let files = data?.rapport_files;
      if (files) setFiles(files);
    });
    setUnsubscribe(() => unsubscribe);
    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [paymentData?.ref]);

  useEffect(() => {
    handleFetchData();
  }, []);

  const handleNotifyAvailableReports = async () => {
    setLoadingEmail(true);
    try {
      const token = await getOrRefreshFirebaseToken();
      if (!folder?.reglement?.infos?.email) {
        handleClickVariant("L'email n'est pas renseigné", "error");
        return;
      }
      const response = await sendAvailableReportsEmail(folder.id, payment_id, token, prefix);
      if (response.success) {
        handleClickVariant("Les rapports ont été envoyés avec succès", "success");
      } else {
        handleClickVariant("Erreur lors de l'envoi des rapports", "error");
      }
    } catch (error) {
      console.error("Error notifying available reports:", error);
      handleClickVariant("Erreur lors de l'envoi des rapports", "error");
    } finally {
      setLoadingEmail(false);
    }
  };

  const [loadingData, setLoadingData] = useState(null);
  const [loadingEmail, setLoadingEmail] = useState(false);

  const handleDeleteFile = async (file) => {
    let newFiles = files.filter((f) => f.name !== file.name);
    await updateDocDataFieldApi(
      paymentData.ref,
      "rapport_files",
      newFiles,
      prefix
    );
    handleLoadUrl();
    handleUpdate();
  };

  return (
    <div className="flex flex-col gap-2 h-full">
      <PDFModal
        type={"rapport-payment"}
        document={{ id: "rapport-payment" + "-" + payment_id }}
        folder={folder}
        onFetch={handleUpdate}
        userData={userData}
        prefix={prefix}
        handleDeleteFile={handleDeleteFile}
        orgData={orgData}
        setLoadingData={setLoadingData}
      >
        <SecondaryButton disabled={loadingData !== null}>
          Voir les rapports
          <SmallSpinner loading={loadingData} margin={0} size={20} />
        </SecondaryButton>
      </PDFModal>{" "}
      {isFolderMaster(orgData, folder) && (
        <Tippy
          content={` Notifier le ${folder.client_type === "particulier" ? "particulier" : folder.client_type === "architect" ? "particulier + client" : "client"} que les rapports sont disponibles`}
          delay={500}
          className="custom-tooltip"
        >
          <div>
            <SecondaryButton
              onClick={handleNotifyAvailableReports}
              className={"w-fit"}
              disabled={loadingEmail || paymentData?.state !== "paid"}
            >
              Envoyer les rapports
              <SmallSpinner loading={loadingEmail} margin={0} size={20} />
            </SecondaryButton>
          </div>
        </Tippy>
      )}
    </div>
  );
};

export default PaymentRapportVisualisateur;
